import styled from '@emotion/styled'
import { Button } from 'components/button/Button'
import { Icon } from 'components/icon'
import { PerksList } from 'components/perksList/PerksList'
import { Stack } from 'components/Stack'
import { Text, Title } from 'components/Typography'
import { describeDirective } from 'logic/directive/describe'
import { SimpleFlowDirectiveType } from 'logic/directive/types'
import { useTranslation } from 'next-i18next'
import { useAuth } from 'utils/auth/hooks/useAuth'
import { colors } from 'utils/colors'
import { numberRange, toLowerCase } from 'utils/general'

const SCardWrapper = styled.div`
  max-width: 400px;
  box-shadow: 0px 5px 40px 0px #d2dce1;
  background: #ffffff;
  padding: 2rem 1.5rem;
`

type DirectivePricingCardProps = {
  directive: SimpleFlowDirectiveType
  color?: string
  sendAnalyticsStartEvent: () => void
}

export function DirectivePricingCard({
  directive,
  color,
  sendAnalyticsStartEvent,
}: DirectivePricingCardProps) {
  const { isLogged } = useAuth()
  const ctxTranslationKey = `${toLowerCase(directive)}_card` as const
  const { t } = useTranslation('pricing_plan')
  const perks = numberRange(5).map((i) => ({
    title: '',
    description: t(`pricing_plan.pricing_flow.cards.${ctxTranslationKey}.perks.perk_${i}`),
  }))

  const sendAnalyticsThenStartDirective = () => {
    if (isLogged == null) return
    sendAnalyticsStartEvent()
  }
  return (
    <SCardWrapper>
      <Stack space="1rem" css={{ alignItems: 'center' }}>
        <Title variant="h6">
          {t(`pricing_plan.pricing_flow.cards.${ctxTranslationKey}.title`)}
        </Title>
        <Text css={{ textAlign: 'center' }}>
          {t(`pricing_plan.pricing_flow.cards.${ctxTranslationKey}.caption`)}
        </Text>
        <Button
          type="button"
          block
          size="large"
          customColor={color}
          onClick={sendAnalyticsThenStartDirective}
        >
          {t(`pricing_plan.pricing_flow.cards.${ctxTranslationKey}.button_text`)}
        </Button>
        <Stack space="0.5rem">
          <PerksList
            perks={perks}
            icon={<Icon name="CheckSimple" color={colors.blue[500]} size="1rem" />}
          />
        </Stack>
        <Button
          type="button"
          variant="text"
          customColor={color}
          href={describeDirective(directive).getLandingPageUrl()}
        >
          {t('pricing_plan.pricing_flow.cards.learn_more_button')}
        </Button>
      </Stack>
    </SCardWrapper>
  )
}
